import { useState } from 'react';
import { FormProvider, Flex, Card } from 'dash-ui';
import { FormFieldsList } from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageForm/constants/constants';
import MortgageForm from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageForm/MortgageForm';
import MortgageModal from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageModal/MortgageModal';
import MortgageHeader from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageHeader/MortgageHeader';

function MortgageCalculatorWidget() {
  const [isShowModal, setIsShowModal] = useState(false);

  return (
    <FormProvider fieldsList={FormFieldsList}>
      <Card p={4} w="100%">
        <Flex flexDirection="column">
          <MortgageHeader />
          <Flex mt={0.5}>
            <MortgageForm onSubmit={() => setIsShowModal(true)} />
          </Flex>
          <MortgageModal
            isOpen={isShowModal}
            onRequestClose={() => setIsShowModal(false)}
          />
        </Flex>
      </Card>
    </FormProvider>
  );
}

export default MortgageCalculatorWidget;
